export const Sub = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="26" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
<mask id="path-2-inside-1_1_5631" fill="white">
<rect x="7" y="13" width="23" height="17" rx="1"/>
</mask>
<rect x="7" y="13" width="23" height="17" rx="1" stroke="currentColor" stroke-width="4" mask="url(#path-2-inside-1_1_5631)"/>
<path d="M4 9L28 9" stroke="currentColor" stroke-width="2"/>
<path d="M8 20L28 20" stroke="currentColor" stroke-width="2"/>
<circle cx="7" cy="6" r="0.5" stroke="currentColor"/>
<circle cx="12" cy="17" r="0.5" stroke="currentColor"/>
<circle cx="10" cy="6" r="0.5" stroke="currentColor"/>
<circle cx="15" cy="17" r="0.5" stroke="currentColor"/>
<circle cx="13" cy="6" r="0.5" stroke="currentColor"/>
<circle cx="18" cy="17" r="0.5" stroke="currentColor"/>
</svg>`;
